export const AddressVerificationLevel = {
  LEVEL_0: 'unverified',
  LEVEL_1: 'mapsVerified',
  LEVEL_2: 'geoVerified',
  LEVEL_3: 'mailVerified',
  LEVEL_4: 'physicalVerified',
} as const;

export type AddressVerificationLevel = (typeof AddressVerificationLevel)[keyof typeof AddressVerificationLevel];

export interface AddressObject {
  address: string;
  place_id: string;
  street: string;
  city: string;
  state: string;
  stateCode: string;
  province: string;
  country: string;
  postalCode: string;
  latitude: number;
  longitude: number;
  mapUrl: string;
}

export interface IUserAddress {
  line1: string;
  line2?: string;
  city: string;
  region: string;
  postalCode: string;
  country: import('@/lib').SupportedCountryCodes;
}

export interface IMailingAddress {
  address?: string | null;
  addressVerificationLevel?: AddressVerificationLevel;
  country?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  province?: string | null;
  mapsAddressObject?: AddressObject;
}
